<template>
    <div class="row">
      <loading
        :active.sync="loader.isLoading"
        :can-cancel="loader.canCancel"
        :is-full-page="loader.fullPage"
        :color="loader.color"
        :height="loader.height"
        :width="loader.width"
        :background-color="loader.backgroundColor"
        :loader="loader.loader">
        </loading>
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Inventory Transfer</h5>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <div class="form-inline ml-auto">
                  <div class="button-group">
                    <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                      <i class="fa fa-filter" aria-hidden="true"></i>
                        Filter
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu p-2" >
                      <span>Category:</span>
                      <div class="dropdown-divider"></div>
                      <!-- <li v-for="ct in salesCategoryList" :key="ct.id">
                        <a href="#" class="small" tabIndex="-1">
                          <input type="checkbox" :value="ct.id" v-model="filterCategory"/>&nbsp; {{ ct.name }}
                        </a>
                      </li> -->
                    </ul>
                    <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addInventory">
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn btn-sm  btn-soft-primary waves-light waves-effect" @click="refreshInventory">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                    </button>
                    rows:
                    <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                      <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                    </select>
                    <span class="mr-1">
                      Total rows: <b>{{ filterData.length }}</b>
                    </span>
                    <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshInventory"></date-picker>
                  </div>
                  <div class="form-group mx-sm-3 mb-2">
                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                  </div>
                  <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                  <nav aria-label="Page navigation example" class="pull-right">
                      <ul class="pagination">
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                              </a>
                          </li>
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </a>
                          </li>
                      </ul>
                  </nav>
                </div>
                <table class="table table-item mb-0 table-sm table-striped">
                    <thead>
                        <tr>
                            <th>
                              <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll" @click="select">
                                <i class="form-icon"></i>
                              </label>
                            </th>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                {{ t.name }}
                                <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                            <th>#</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="11" style="text-align: center;"><i>No Data</i></td>
                      </tr>
                      <tr v-for="u in filterData" v-bind:key="u.id" style="cursor: pointer">
                        <td>
                          <label class="form-checkbox">
                            <input type="checkbox" :value="u.id" v-model="selected">
                            <i class="form-icon"></i>
                          </label>
                        </td>
                        <td @click="editInventory(u.id)">{{ u.branch_no }}</td>
                        <td @click="editInventory(u.id)">{{ u.transfer_no }}</td>
                        <td @click="editInventory(u.id)">{{ u.transfer_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td @click="editInventory(u.id)">{{ u.warehouse_origin }}</td>
                        <td @click="editInventory(u.id)">{{ u.warehouse_to }}</td>
                        <td>
                          <button type="button" class="btn btn-primary btn-sm" @click="print(u.id)"><i class="fa fa-print"></i> Print</button>
                        </td>
                      </tr>
                    </tbody>
                </table>
              </div>
            </div>
          </div>
      </div>
      <!-- <pre>{{ dataRaw }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'
import { getHeader, inventoryUrl, printInventoryUrl } from '../../config'

export default {
  name: 'PurchasingList',
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Branch',
        prop: 'branch_no'
      }, {
        name: 'Transfer No.',
        prop: 'transfer_no'
      }, {
        name: 'Date',
        prop: 'transfer_date'
      }, {
        name: 'Warehouse Origin',
        prop: 'warehouse_origin'
      }, {
        name: 'Warehouse To',
        prop: 'warehouse_to'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshInventory()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    print: function (id) {
      window.open(printInventoryUrl + '/transfer/print/' + id, '_blank')
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editInventory (id) {
      axios.get(inventoryUrl + '/transfer/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data)
          this.$emit('editInventory', response.data.data)
        })
        .catch(error => {
          this.$swal(
            'Error!!!',
            '</pre>' + error.response + '</pre>',
            'error'
          )
        })
    },
    addInventory () {
      this.$emit('newInventory', true)
    },
    refreshInventory () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = inventoryUrl + '/transfer' + '?begin=' + begin + '&end=' + end
      console.log(url)
      axios.get(url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response)
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.currentPage = 1
          this.searchQuery = ''
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    }
  }
}
</script>
